import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  chartMarkers: {
    PopulationOverTimeChart: {lineLabels: {}},
    RiskOverTimeChart: {lineLabels: {}}
  }
}

const chartMarkerSlice = createSlice({
  name: 'chartMarker',
  initialState,
  reducers: {
    setChartMarkers: (state, action) => {
      state.chartMarkers = action.payload
    },
    updateChartMarker: (state, action) => {
      const {chartName, markerType, key, value} = action.payload
      if (state.chartMarkers?.[chartName]?.[markerType]) {
        state.chartMarkers[chartName][markerType][key] = value
      }
    },
    updateChartMarkerData: (state, action) => {
      const {chartName, lineLabels} = action.payload
      if (state.chartMarkers?.[chartName]) {
        if (lineLabels !== undefined) {
          state.chartMarkers[chartName].lineLabels = lineLabels
        }
      }
    },
    clearChartMarkers: (state) => {
      state.chartMarkers = {
        PopulationOverTimeChart: {lineLabels: {}},
        RiskOverTimeChart: {lineLabels: {}}
      }
    }
  }
})

export const {setChartMarkers, updateChartMarker, updateChartMarkerData, clearChartMarkers} = chartMarkerSlice.actions

export const selectChartMarkers = (state) => state.chartMarker.chartMarkers

export default chartMarkerSlice.reducer
